<template>
  <div class="containerNotFound">
	<h1>404</h1>
	<p>
		La dirección que intentas acceder no existe.
	</p>
	<div class="circle small"></div>
	<div class="circle medium"></div>
	<div class="circle big"></div>
</div>
</template>
<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

  :root {
    --pink1: #EF73CB;
    --pink2: #DC5F89;
  }


  .containerNotFound {
    background-image: url('https://sotapar.com/wp-content/uploads/2020/12/error-putt-sota-par.jpg');
    overflow: hidden;
    position: relative;
    align-items: center;
    color: #fff;
    display: flex;
    flex-direction: column;
    font-family: 'Roboto', sans-serif;
    justify-content: center;
    height: 100vh;
    text-align: center;
  }

  .containerNotFound h1 {
    font-size: 20em;
    margin: 0 0 0.5em;
    line-height: 10px;
  }

  .containerNotFound p {
    font-size: 2.2em;
    line-height: 26px;
  }

  .containerNotFound small {
    opacity: 0.7;
  }

  .containerNotFound a {
    color: #eee;
  }

  .circle {
    background-image: linear-gradient(to top right, var(--pink1), var(--pink2));
    border-radius: 50%;
    position: absolute;
    z-index: -1;
  }

  .circle.small {
    top: 200px;
    left: 150px;
    width: 100px;
    height: 100px;
  }

  .circle.medium {
    background-image: linear-gradient(to bottom left, var(--pink1), var(--pink2));
    bottom: -70px;
    left: 0;
    width: 200px;
    height: 200px;
  }

  .circle.big {
    top: -100px;
    right: -50px;
    width: 400px;
    height: 400px;
  }

  @media screen and (max-width: 480px) {
    .containerNotFound h1 {
      font-size: 8em;
    }
    
    .containerNotFound p {
      font-size: 1em;
    }
  }

  footer {
    background-color: #222;
    color: #fff;
    bottom: 0;
    position: fixed;
    left: 0;
    right: 0;
    letter-spacing: 1px;
    text-align: center;
  }

  footer p {
    font-size: 1em;
    margin: 5px 0;
  }

  footer i {
    color: red;
  }

  footer a {
    color: #3C97BF;
    text-decoration: none;
  }
</style>
<script>
export default {
    props: [],
    data() {
      return {
      
      }
    },
    mounted: function () {
        this.titulo = this.title;
        /*document.addEventListener("keydown", (e) => {
            if (this.show && e.keyCode == 27) {
                this.close()
            }
        })*/
    },
    computed:{
        showModal(){
          return this.show;
        },
        scroll(){
            if(this.disableScroll){
                return false;
            }else{
                return true;
            }
        }
    },
    methods: {
        /*toggle() {
            let toggleValue = !this.showModal;
            this.$emit('toggle',toggleValue);
        },*/
        toggle() {
            this.$emit("input", !this.value);
        },
        setTitle(value){
            this.titulo = value;
        }
    }
}
</script>